import { Button, Checkbox, MaskedInput, UIHeading2, UIText3, UIText1 } from '@cian/ui-kit';
import React from 'react';
import styles from './styles.css';
import { type ValidationError } from '../../types';
import { isPhoneError, isAgreementError } from '../../utils';

interface IPhoneFormProps {
  phone: string;
  onPhoneChange: (value: string) => void;
  onAgreeToGetAdsChange: (event: React.ChangeEvent<HTMLInputElement>, value: boolean) => void;
  agreeToGetAds: boolean;
  onSubmit: () => void;
  error: ValidationError;
  isLoading: boolean;
}

const PRIVACY_POLICY_URL = 'https://www.cian.ru/legal-documents/politika_konfidencialnosti_0/';
const LEAD_PD_CONSENT_B2C_URL =
  'https://static.cdn-cian.ru/frontend/mortgage-assets/documents/PhoneRefinBanner/soglasie_zaemshchika_na_pd_b2c.docx';

const LEAD_AD_CONSENT_B2C_URL =
  'https://static.cdn-cian.ru/frontend/mortgage-assets/documents/PhoneRefinBanner/soglasie_zaemshchika_na_reklamu_b2c.docx';

export const PhoneForm: React.FC<IPhoneFormProps> = ({
  phone,
  onPhoneChange,
  onAgreeToGetAdsChange,
  agreeToGetAds,
  onSubmit,
  error,
  isLoading,
}) => {
  return (
    <>
      <UIHeading2>Оставьте телефон — и мы сообщим вам, когда ставки упадут</UIHeading2>
      <div className={styles['phone-container']}>
        <MaskedInput
          data-testid="lead-phone-input"
          required
          size="M"
          leftAdornment={
            <span className={styles['phone-prefix']}>
              <UIText1>+7</UIText1>
            </span>
          }
          onChange={onPhoneChange}
          mask="000 000 00 00"
          value={phone}
          placeholder="000 000 00 00"
          invalid={isPhoneError(error)}
        />
      </div>
      <div className={styles['privacy-policy']}>
        <UIText3 color="text-secondary-default">
          Отправляя данные, я соглашаюсь с{' '}
          <a target="_blank" href={PRIVACY_POLICY_URL} rel="noopener noreferrer">
            политикой конфиденциальности
          </a>{' '}
          и даю согласие на{' '}
          <a target="_blank" href={LEAD_PD_CONSENT_B2C_URL} rel="noopener noreferrer">
            обработку персональных данных
          </a>
        </UIText3>
      </div>
      <div className={styles['checkbox']}>
        <Checkbox
          onChange={onAgreeToGetAdsChange}
          checked={agreeToGetAds}
          name="agreeToGetAds"
          id="agreeToGetAds"
          invalid={isAgreementError(error)}
        />
        <label htmlFor="agreeToGetAds">
          <UIText3 color="text-secondary-default">
            Соглашаюсь получать{' '}
            <a href={LEAD_AD_CONSENT_B2C_URL} rel="noopener noreferrer" target="_blank">
              рекламу
            </a>
          </UIText3>
        </label>
        {error && (
          <div className={styles['error']}>
            <UIText3 color="text-negative-default">{error.text}</UIText3>
          </div>
        )}
      </div>
      <Button onClick={onSubmit} loading={isLoading} fullWidth data-testid="lead-phone-submit-button">
        Хочу узнать
      </Button>
    </>
  );
};
